<template>
  <b-container>
    <div class="expired-link-container">
      <div class="expired-card text-center">
        <div class="icon-container">
          <img
            class="icon"
            :src="require(`@/assets/images/icons/invalid-payment-link.svg`)"
            alt="Invalid Link Icon"
          />
        </div>

        <h2 class="title">{{ t.invalidLink }}</h2>

        <p class="description">
          {{ t.invalidLinkDescription }}
        </p>
      </div>
    </div>
  </b-container>
</template>

<script>
import translations from "@/views/pages/secure-payment-form/data/translations.js";

export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
  },
  computed: {
    t() {
      return translations[this.selectedLanguage];
    },
  },
};
</script>

<style lang="scss">
/* Global container with flexible properties */
.expired-link-container {
  max-width: 90vw;
  margin: 0 auto;
  margin-top: 3rem;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Montserrat", sans-serif !important;

  /* Title styling with responsive scaling */
  .title {
    margin-top: 2rem;
    font-size: clamp(
      1.6rem,
      5vw,
      2.5rem
    ); /* Font size dynamically adjusts between 1.6rem and 2.5rem based on screen width */
    font-weight: 700 !important;
    margin-bottom: 1rem;
    color: #0090e7;
  }

  /* Description styling with responsive scaling */
  .description {
    font-size: clamp(
      1.2rem,
      4vw,
      1.5rem
    ); /* Font size dynamically adjusts between 1.2rem and 1.5rem based on screen width */
    color: #6e6e6e;
    margin-bottom: 2rem;
    font-weight: 700 !important;
  }

  /* Card styling with adjusted padding and max-width */
  .expired-card {
    max-width: calc(100% - 40px);
    padding: calc(1.5rem + 1px);
  }

  /* Icon container styling */
  .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
  }

  /* Icon styling with scaling on different screens */
  .icon {
    color: #dc3545;
    max-width: 15vw; /* Icon scales dynamically on screen size */
  }

  /* Media Queries for responsive adjustments */

  /* Mobile screens */
  @media (max-width: 576px) {
    .title {
      font-size: clamp(1.4rem, 6vw, 2rem);
    }

    .description {
      font-size: clamp(1.1rem, 5vw, 1.4rem);
    }

    .icon {
      max-width: 25vw;
    }
  }

  /* Tablets */
  @media (max-width: 768px) {
    .title {
      font-size: clamp(1.5rem, 5vw, 2.2rem);
    }

    .description {
      font-size: clamp(1.15rem, 4.5vw, 1.45rem);
    }

    .icon {
      max-width: 20vw;
    }
  }

  /* Laptops & Small desktops */
  @media (max-width: 1024px) {
    .title {
      font-size: clamp(1.6rem, 4.5vw, 2.4rem);
    }

    .description {
      font-size: clamp(1.2rem, 4vw, 1.5rem);
    }

    .icon {
      max-width: 18vw;
    }
  }

  /* Large desktops */
  @media (min-width: 1200px) {
    .title {
      font-size: clamp(1.6rem, 3vw, 2.5rem);
    }

    .description {
      font-size: clamp(1.2rem, 3vw, 1.6rem);
    }

    .icon {
      max-width: 15vw;
    }
  }
}

.dark-layout {
  .expired-link-container {
    .title {
      color: #0090e7;
    }
  }
}
</style>
